import getPlayfieldPosition from './playfieldPosition';
import './MuzzleFlash.css';

function MuzzleFlash({ muzzleFlash }) {
  return (
    <div
      className="muzzle-flash"
      style={getPlayfieldPosition(muzzleFlash.x, muzzleFlash.y)}
      aria-hidden="true"
    />
  );
}

export default MuzzleFlash;
